// Ren geometri for «er punktet nær kanten av kartutsnittet?».
// Brukes til å avgjøre om vi skal re-sentrere kartet mens vi følger GPS-prikken,
// slik at vi kun panorerer når prikken faktisk driver mot kanten — ikke på hver
// eneste GPS-fix. Holdt fri for Leaflet slik at den kan enhetstestes.

export interface ViewportBounds {
  south: number;
  north: number;
  west: number;
  east: number;
}

/**
 * Returnerer true hvis (lat, lng) ligger innenfor `threshold` (0–1) av en av
 * utsnittets kanter. threshold = 0.20 betyr «innerste 60 % er trygt, ytterste
 * 20 % på hver side regnes som nær kanten».
 *
 * Degenererte bounds (null-høyde/-bredde) regnes som «nær kant» slik at kalleren
 * heller re-sentrerer enn å stå fast.
 */
export function isPointNearViewportEdge(
  b: ViewportBounds,
  lat: number,
  lng: number,
  threshold = 0.20,
): boolean {
  const latSpan = b.north - b.south;
  const lngSpan = b.east - b.west;
  if (latSpan <= 0 || lngSpan <= 0) return true;
  const latFrac = (lat - b.south) / latSpan;
  const lngFrac = (lng - b.west) / lngSpan;
  return (
    latFrac < threshold ||
    latFrac > 1 - threshold ||
    lngFrac < threshold ||
    lngFrac > 1 - threshold
  );
}
